import React, { ComponentType } from 'react';
import { Navigate } from 'react-router';

export function withAccessRedirect() {
  return (useHasAccess: () => boolean, redirectPath = '/') =>
    <P extends object>(DecoratedComponent: ComponentType<P>) =>
      (props: P) => {
        const hasAccess = useHasAccess();

        if (hasAccess) {
          return <DecoratedComponent {...props} />;
        }

        return <Navigate to={redirectPath} />;
      };
}

export default withAccessRedirect();
